<template>
    <!--
      =========================================
       USE APPBAR AND DRAWER INSTEAD OF NAVBAR
              @/viewS/components/core
      =========================================
     -->
    <nav>
        <v-snackbar v-model="notifMSG" top> {{ notifText }}
            <v-btn color="pink" text @click="notifMSG = false"> Close</v-btn>
        </v-snackbar>
        <v-app-bar dark app>
            <v-btn depressed @click="drawer = !drawer" x-small class="menu">
                <v-icon>menu</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <!-- <v-toolbar-title class="text-uppercase ml-4 center">
              <span class="font-weight-light">Climate-</span>
              <span>RX</span>

            </v-toolbar-title> -->
            <v-img src="../assets/ICON.png" max-height="100" max-width="115" id="mainLogo"></v-img>
            <v-spacer></v-spacer>


            <v-menu
                v-model="menu"
                :disabled="disabled"
                :absolute="absolute"
                :open-on-hover="openOnHover"
                :close-on-click="closeOnClick"
                :close-on-content-click="false"
                :offset-x="offsetX"
                :offset-y="offsetY"
            >
                <template v-slot:activator="{ on, attrs }">

                    <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        class="mr-1"
                    >
                        <v-badge
                            color="green"
                            :content="notificationsTotal"
                            :value="notificationsTotal"
                            overlap
                            show

                        >
                            <v-icon>notifications</v-icon>
                        </v-badge>
                    </v-btn>

                </template>
                <v-card
                    max-width="450"
                    min-width="400"
                    class="mx-auto"
                >
                    <v-toolbar>
                        <!--<v-app-bar-nav-icon></v-app-bar-nav-icon>-->
                        <v-toolbar-title>Notifications({{ notificationsTotal }})</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn text small class="text-capitalize" @click="menu = false" link router to="/notifications">
                            View All Notifications
                        </v-btn>
                    </v-toolbar>
                    <v-list three-line
                            max-height="300"
                            class="overflow-x-auto"
                            nav
                    >
                        <template v-for="(item, index) in notifications">
                            <!--
                            <v-subheader
                              v-if="item.Status"
                              :key="item.Status"
                              v-text="item.Status"
                            ></v-subheader>

                            <v-divider
                              v-else-if="item.divider"
                              :key="index"
                              :inset="item.inset"
                            ></v-divider>
                            -->
                            <v-list-item
                                :key="index"
                            >
                                <v-list-item-avatar>
                                    <v-img v-bind:src="item.user.Image"></v-img>
                                </v-list-item-avatar>

                                <v-list-item-content style="align-self: auto">
                                    <v-list-item-title v-html="item.user.Name"></v-list-item-title>
                                    <v-list-item-subtitle v-html="item.notification.Title"></v-list-item-subtitle>
                                    <v-list-item-subtitle v-html="item.notification.CreatedDate"
                                                          class="font-weight-light font-italic"
                                                          style="font-size:11px;"></v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-list-item-action-text>
                                        <v-btn icon
                                               title="Mark as Read">
                                            <v-icon small
                                                    @click="viewNotification(item._id)">mdi-bell-remove-outline
                                            </v-icon>
                                        </v-btn>
                                    </v-list-item-action-text>
                                </v-list-item-action>

                            </v-list-item>
                        </template>
                    </v-list>

                </v-card>

            </v-menu>
            <v-btn @click="logoutUser" depressed>

                <v-icon right>exit_to_app</v-icon>
            </v-btn>
        </v-app-bar>

        <v-navigation-drawer
            v-model="drawer"
            app
            dark
            expand-on-hover
            width="200"
        >
            <v-list nav>
                <v-list-item dark class="px-2">
                    <v-list-item-avatar>
                        <v-img v-bind:src="profileimg"></v-img>
                    </v-list-item-avatar>

                    <v-list-item router to="/userprofile">
                        <v-list-item-title>{{userName}}</v-list-item-title>
                    </v-list-item>
                    <v-spacer></v-spacer>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-group
                    prepend-icon="account_circle"
                >
                    <template v-slot:activator>
                        <v-list-item-title>Admin</v-list-item-title>
                    </template>
                    <v-list-group
                        no-action
                        sub-group
                    >
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>Settings</v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-list-group
                            no-action
                            sub-group
                        >
                            <template v-slot:activator>
                                <v-list-item-content>
                                    <v-list-item-title>Client</v-list-item-title>
                                </v-list-item-content>
                            </template>


                            <v-list-item
                                v-for="client in clients"
                                :key="client.title"
                                router :to="client.route"
                                class="ml-n12"
                            >
                                <v-list-item-title class="pl-10">{{client.text}}</v-list-item-title>
                                <v-list-item-icon>
                                    <v-icon>{{client.icon}}</v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                        </v-list-group>
                        <v-list-group
                            no-action
                            sub-group
                        >
                            <template v-slot:activator>
                                <v-list-item-content>
                                    <v-list-item-title>Staff</v-list-item-title>
                                </v-list-item-content>
                            </template>


                            <v-list-item
                                v-for="employee in employees"
                                :key="employee.title"
                                router :to="employee.route"
                                class="ml-n12"
                            >
                                <v-list-item-title class="pl-10">{{employee.text}}</v-list-item-title>
                                <v-list-item-icon>
                                    <v-icon>{{employee.icon}}</v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                        </v-list-group>

                    </v-list-group>
                </v-list-group>

                <v-list-item
                    v-for="dash in dashboard"
                    :key="dash.route"
                    router :to="dash.route"
                >
                    <v-list-item-icon>
                        <v-icon>mdi-home</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>Dashboard</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-for="company in companies"
                    :key="company.text"
                    router :to="company.route"
                >
                    <v-list-item-icon>
                        <v-icon>{{company.icon}}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>{{company.text}}</v-list-item-title>
                </v-list-item>
            </v-list>
            <!-- <v-list class='signOut'>
              <v-list-item @click="logoutUser" class="mt-16" absolute bottom>

                <v-list-item-icon>
                  <v-icon>exit_to_app</v-icon>
                </v-list-item-icon>

                <v-list-item-title>Sign Out</v-list-item-title>
              </v-list-item>
            </v-list> -->
        </v-navigation-drawer>
    </nav>
</template>

<script>
    import {mapActions} from "vuex";
    import axios from 'axios';
    import moment from 'moment'
    import DateTimeUtil from '../../utils/date-time.util';

    const url = require("../client_config/config").url;

    export default {
        data: () => ({
            show: false,
            drawer: true,
            profileimg: "",
            userID: "",
            userName: "",
            user: [],
            disabled: false,
            absolute: false,
            value: false,
            closeOnClick: true,
            closeOnContentClick: true,
            openOnHover: false,
            menu: false,
            offsetX: false,
            offsetY: true,
            notifications: [],
            notificationsTotal: 0,
            notifMSG: false,
            notifText: "",
            dashboard: [
                {route: '/dashboard'},
            ],
            companies: [
                {text: 'Shifts', icon: 'schedule', route: '/shifts'},
                {text: 'Staff', icon: 'person', route: '/employees'},
                {text: 'Clients', icon: 'accessibility_new', route: '/client'},
                {text: 'Reports', icon: 'bar_chart', route: '/reports'},
                {text: 'Calendar', icon: 'event', route: '/calendar'},
                {text: 'Tasks', icon: 'event', route: '/tasks'},
                {text: 'Training', icon: 'school', route: '/training'},

            ],
            clients: [
                {text: 'Service Codes', icon: 'person', route: '/codes'},

            ],
            employees: [
                {text: 'Certifications', icon: 'check', route: '/staffCertification'},
                {text: 'Notifications', icon: 'schedule', route: '/notifications'},
                {text: 'Programs', icon: 'apartment', route: '/unit'},
                {text: 'Users', icon: 'person', route: '/users'},

            ],
        }),
        created() {
            this.userID = localStorage.getItem('userID');
            this.getUserInfo(this.userID);
            if (localStorage.getItem('userRole') === "Administration") {
                this.admin = true;
                // }else if( localStorage.getItem('userRole')=="Staff - HR"){
                //   console.log(this.salesrep);
                //   this.salesrep = true;
                //   this.sidebar=[0]
                // }else if( localStorage.getItem('userRole')=="Staff - Direct Care"){
                //   this.manager = true;
                //   this.sidebar=[0]
            }
            this.getNotifications();

        },
        computed: {},
        methods: {

            initialize() {
                this.notifications = [];
            },
            ...mapActions(["logout"]),
            async logoutUser() {
                const response = await axios.post(`${url}/users/logout`);

                if (response.data.success) {
                    await this.logout();
                    window.location.href = "/";
                }
            },
            getUserInfo: function (id) {
                axios.get(`${url}/users/${id}`).then(res => {
                    this.userName = res.data.user.Name;
                    this.profileimg = res.data.user.Image;
                    console.log(res.data);
                });
            },
            getNotifications() {
                axios.get(`${url}/notifications/auth-user`).then(response => {
                    const {docs, totalDocs} = response.data;
                    this.notificationsTotal = totalDocs || 0;
                    this.notifications = docs.map(notification => {
                        notification.createdAt = DateTimeUtil.toLocalDateTime(notification.createdAt);
                        notification.updatedAt = DateTimeUtil.toLocalDateTime(notification.createdAt);
                        return notification;
                    });
                });
            },

            computeDate(dateNotif) {
                var dt = new Date();
                var dat = moment(dt).format("YYYY-MM-DD HH:mm:ss");
                dat = moment(dat);
                var differenceInMs2 = dat.diff(dateNotif); // diff yields
                var duration = moment.duration(differenceInMs2); // moment.duration accepts ms
                var differenceInSeconds = Math.floor(duration.asSeconds());
                var differenceInMinutes = Math.floor(duration.asMinutes());
                var differenceInHours = Math.floor(duration.asHours());
                let differenceInDays = Math.floor(duration.asDays());

                let result = 0;
                if (differenceInSeconds > 0 && differenceInMinutes <= 0 && differenceInHours <= 0) {
                    result = differenceInSeconds + ' second(s) ago.';
                } else if (differenceInSeconds > 0 && differenceInMinutes > 0 && differenceInHours <= 0) {
                    result = differenceInMinutes + ' minute(s) ago.';
                } else if (differenceInSeconds > 0 && differenceInMinutes > 0 && differenceInHours > 0 && differenceInHours <= 24) {
                    result = differenceInHours + ' hour(s) ago.';
                } else if (differenceInSeconds > 0 && differenceInMinutes > 0 && differenceInHours > 0 && differenceInHours > 24 && differenceInDays <= 31) {
                    result = differenceInDays + ' day(s) ago.';
                } else {
                    result = moment(dateNotif).format("MMM D YYYY");
                }
                return result;
            },
            viewNotification(notificationID) {
                //confirm("Are you sure you want to remove this notification?") &&
                this.notificationViewed(notificationID);
                this.notifMSG = true;
                this.notifText = "The notification has been successfully removed.";

            },
            notificationViewed(id) {
                axios.put(`${url}/notifications/${id}`)
                    .then((response) => {
                        this.getNotifications();
                        if (response.status == 400) {
                            response.json().then(function (data) {
                                return data.msg;
                            });
                        }
                    });
            },

        },

    }
</script>
<style>

    .signOut {
        margin-top: 250px;
    }

    @media only screen and (min-width: 600px) {
        .v-btn.menu {
            display: none;
        }


    }

    @media only screen and (max-width: 480px) {
        .v-menu.desktop {
            display: block;
        }

        #mainLogo {
            height: 45px;
            width: 80px;
            margin-top: 0px;
            padding-top: 0px;
        }

    }
</style>
